import { render, staticRenderFns } from "./collectionsRevamped.vue?vue&type=template&id=141a262a&scoped=true&"
import script from "./collectionsRevamped.vue?vue&type=script&lang=js&"
export * from "./collectionsRevamped.vue?vue&type=script&lang=js&"
import style0 from "./collectionsRevamped.vue?vue&type=style&index=0&id=141a262a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a262a",
  null
  
)

export default component.exports